import React from 'react';
import {
    HeadingText20,
    ComponentTextSmall,
    Icon,
    Icons,
    HexOrNamedColor,
} from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import styled from '@emotion/styled';
import { LinkProps, Link } from 'react-router-dom';

interface Props {
    title: string;
    subtitle: string;
    to: LinkProps['to'];
    active: boolean;
    color: HexOrNamedColor;
    icon: Icons;
}

export const TopicListItem = ({ title, subtitle, to, active, color, icon }: Props) => {
    return (
        <StyledLink active={active} to={to} aria-current={active ? 'page' : undefined}>
            <StyledComponentTextSmall fontColor={active ? 'gray85' : 'gray65'}>
                <StyledIconWrapper backgroundColor={color}>
                    <Icon name={icon} size={8} color="white" />
                </StyledIconWrapper>
                {subtitle}
            </StyledComponentTextSmall>
            <HeadingText20 fontColor={active ? 'gray85' : 'gray65'}>{title}</HeadingText20>
        </StyledLink>
    );
};

const BORDER_LEFT_WIDTH_ACTIVE = 6;
const BORDER_WIDTH = 2;
const PADDING_LEFT = 15;

const StyledLink = styled(Link, { shouldForwardProp: prop => prop !== 'active' })(
    ({ active }: { active: boolean }) => ({
        padding: 21,
        paddingLeft: active ? PADDING_LEFT : BORDER_LEFT_WIDTH_ACTIVE - BORDER_WIDTH + PADDING_LEFT,
        borderStyle: 'solid',
        borderWidth: BORDER_WIDTH,
        borderColor: active ? colors.blue55 : colors.gray05,
        borderLeftWidth: active ? BORDER_LEFT_WIDTH_ACTIVE : undefined,
        color: colors.gray85,
        backgroundColor: active ? colors.blue05 : 'transparent',
        borderRadius: 8,
        ':hover': {
            color: 'initial',
        },
    }),
);

const StyledComponentTextSmall = styled(ComponentTextSmall)({
    display: 'flex',
    marginBottom: 8,
});

const StyledIconWrapper = styled.span(
    ({ backgroundColor }: { backgroundColor: HexOrNamedColor }) => ({
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: colors[backgroundColor],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 8,
    }),
);
